<template>
    <v-card flat>
        <v-card-text style="height: 150px; overflow-y: auto" class="pa-0">
            <div class="px-4 pt-2 pb-3 body-2 secondary--text text--lighten-2">
                {{ $t(`${eventPrefix}.monetization.purchase.tip`) }}
            </div>
            <!-- If vewing on screener's detail page, then provide pass detail page link only-->
            <template v-if="screener">
                <router-link
                class="blue--text subheading px-4"
                :to="{
                name: 'pricing.overview',
                params: { pricing_id: pricing.id,},
                }"
                >{{ $t(`${eventPrefix}.plan_detail_here`) }}</router-link>
            </template>
            <!-- if viewing on pass page itself, then only list screener in popup -->
            <template v-else v-for="(screening, index) in pricing.pricingPlanScreenings">
                <v-layout row wrap :key="screening.id" class="px-4 mb-2">
                    <v-flex xs8 class="secondary--text">
                        <!-- Alert for geo blocking -->
                        <v-tooltip top v-if="screening.is_geo_blocked" color="white">
                            <template v-slot:activator="{ on }">
                                <v-icon v-on="on" small color="error" class="px-1">mdi-alert</v-icon>
                            </template>
                            <span class="secondary--text text--darken-3 body-1">
                                {{ $t(`${eventPrefix}.geo_blocked`) }}
                            </span>
                        </v-tooltip>
                        <!-- Ended mark -->
                        <EndedIndicator v-if="!isDateFuture(screening.screening_ends_at)"></EndedIndicator>
                        {{ screening.title }}
                    </v-flex>
                    <v-flex xs4>
                    <div class="body-2 secondary--text">
                        {{ moment.utc(screening.screening_starts_at).local().format("lll") }}
                    </div>
                    </v-flex>
                </v-layout>
                <v-divider class="py-1" v-if="index + 1 < pricing.screening_ids.length" :key="screening.title + index"></v-divider>
            </template>
        </v-card-text>
    </v-card>
</template>

<script>
import EndedIndicator from "@/components/screener/EndedIndicator";
import { isDateFuture } from "@/helpers";

export default {
    name:"ListScreenersInPass",
    props:{
        eventPrefix:{
            type:String,
            default:'screener'
        },
        pricing:{
            type:Object,
            default:null
        },
        screener:{
            type:Object,
            default:null
        }
    },
    components:{
        EndedIndicator
    },
    methods:{
        isDateFuture(date) {
            return isDateFuture(date);
        },
    }
}
</script>

<style>

</style>
